// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   StatusPill
   Two kinds: member · job
   ───────────────────────────────────────────────────────────── */

/* ── Member status dot pill ── */
.status-dot-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-xs);
  font-family: var(--mono);
  color: var(--text-secondary);
}
[data-theme='dark'] .status-dot-pill {
  color: var(--ink-text-2);
}

.status-dot-pill .d {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--text-muted);
}
.status-dot-pill.active .d {
  background: var(--ok);
}
.status-dot-pill.pending .d {
  background: var(--warn);
}

/* ── Job status pill (dot + uppercase label) ── */
.job-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--mono);
  font-size: var(--fs-sm);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary);
}
[data-theme='dark'] .job-status {
  color: var(--ink-text-2);
}

.job-status .d {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}

.job-status.pending .d {
  background: var(--text-muted);
}
.job-status.processing .d {
  background: var(--signal);
  animation: job-pulse 1.2s ease-in-out infinite;
}
.job-status.success .d {
  background: var(--ok);
}
.job-status.error .d {
  background: var(--danger);
}
.job-status.warning .d {
  background: var(--warn);
}

[data-theme='dark'] .job-status.pending .d {
  background: var(--ink-text-3);
}

@keyframes job-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/StatusPill/StatusPill.css"],"names":[],"mappings":"AAAA;;;kEAGkE;;AAElE,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   StatusPill\n   Two kinds: member · job\n   ───────────────────────────────────────────────────────────── */\n\n/* ── Member status dot pill ── */\n.status-dot-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--fs-xs);\n  font-family: var(--mono);\n  color: var(--text-secondary);\n}\n[data-theme='dark'] .status-dot-pill {\n  color: var(--ink-text-2);\n}\n\n.status-dot-pill .d {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--text-muted);\n}\n.status-dot-pill.active .d {\n  background: var(--ok);\n}\n.status-dot-pill.pending .d {\n  background: var(--warn);\n}\n\n/* ── Job status pill (dot + uppercase label) ── */\n.job-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n[data-theme='dark'] .job-status {\n  color: var(--ink-text-2);\n}\n\n.job-status .d {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n}\n\n.job-status.pending .d {\n  background: var(--text-muted);\n}\n.job-status.processing .d {\n  background: var(--signal);\n  animation: job-pulse 1.2s ease-in-out infinite;\n}\n.job-status.success .d {\n  background: var(--ok);\n}\n.job-status.error .d {\n  background: var(--danger);\n}\n.job-status.warning .d {\n  background: var(--warn);\n}\n\n[data-theme='dark'] .job-status.pending .d {\n  background: var(--ink-text-3);\n}\n\n@keyframes job-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(1.4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
